import {StyleSheet} from "react-native";
import {useChat} from "@/lib/components/ChatProvider";
import Page from "@/lib/components/Page";
import {useMemo} from "react";
import Table from "@/lib/components/Table";
import {Color, rowColor} from "@/lib/styles";
import ChatRow from "@/lib/components/ChatRow";
import {useAccount} from "@/lib/components/AccountProvider";
import SpinnerPage from "@/lib/components/SpinnerPage";
import PrimaryText from "@/lib/components/PrimaryText";
import ErrorPage from "@/lib/components/ErrorPage";
import Center from "@/lib/components/Center";
import NavButton from "@/lib/components/NavButton";

export default function Index() {
    const {chats, chatError, unreadChatMessages} = useChat();
    const {account} = useAccount();

    const sortedChats = useMemo(() => {
        if (chats.entries().toArray === undefined) {
            return [];
        }
        const c = chats.entries().toArray();
        c.sort(([_key_a, a], [_key_b, b]) => {
            if (!a.chat.lastActivity || !b.chat.lastActivity) {
                return 0;
            }
            return (b.chat.lastActivity.unixMsec as number) - (a.chat.lastActivity.unixMsec as number);
        });
        return c;
    }, [chats]);

    if (!account) {
        return (
            <Page>
                <Center style={{alignItems: "center"}}>
                    <NavButton href={`/u/account/login`} title={"Logg inn for å chatte"}/>
                </Center>
            </Page>
        );
    }

    if (!chats || !account) {
        const title = !chatError ?
            "Laster chat..." :
            `Venter på å koble til chat...
            
${chatError.message}`;
        return <SpinnerPage title={title}/>
    }
    if (chatError) {
        return <ErrorPage error={chatError}/>
    }

    return (
        <Page scrollable={true}>
            <PrimaryText>Uleste meldinger: {unreadChatMessages}</PrimaryText>
            <Table>
                {sortedChats.map(([key, record], index) => (
                    <ChatRow key={key}
                        // avatar={record.chat}
                        // badge={badge(participant)}
                        // badgeColor={color}
                             id={key}
                             chat={record.chat}
                             messages={record.messages}
                             color={rowColor(Color.Container, index)}
                             contrastColor={Color.PrimaryText}
                        // contrastColor={contrastColor}
                        // onPress={onPress}
                        // onEdit={onEdit ? onEdit(participant.avatar.username) : undefined}
                    />
                ))}
            </Table>
        </Page>
    )
}

export const styles = StyleSheet.create({})